export default __webpack_public_path__ + "static/article-real-stories-saving-spending-lending-shivani-4294c376e052c769567d3962653eb5b4.jpg";